/**
 * Detect fn
 */
export default () => 'startsWith' in String.prototype
